import React, { useEffect, useState } from 'react'
import { RealEstateDataPageComponentData } from 'types'
import { getTextShort } from '@helpers/helper.rendering'
import Slider_6 from '@boilerplates/sliders/1'
import { useGetBlogsQuery } from '@apis/mediacore/blog'
import { getDateTime, orderbyDate, orderbyFeatured } from '@helpers/helper.novelty'
export const NextArrow = (props: any) => {
  return (
    <div
      onClick={props.onClick}
      className="next arrow-custom"
    >
      <i className="icon-arrow-stick-light"></i>
    </div>
  )
}
export const PrevArrow = (props: any) => {
  return (
    <div
      onClick={props.onClick}
      className="prev arrow-custom"
    >
      <i className="icon-arrow-stick-light"></i>
    </div>
  )
}

const Summary_Novelty_5 = (props: RealEstateDataPageComponentData) => {
  const { global_data } = props
  const divisionPath = global_data.divisionPath
  const siteId = global_data.id

  const { data: allBlogData, isLoading, isError } = useGetBlogsQuery({ site: siteId })

  const [isComponentMounted, setIsComponentMounted] = useState(false)
  // Component always depends on screen object, so we need to wait until it's mounted
  useEffect(() => {
    setIsComponentMounted(true)
  }, [])

  function makeObject() {
    const objects: {
      photo?: string
      top_string?: string | number
      title?: string
      paragraph?: string
      link?: string
      cta?: string
    }[] = orderbyFeatured(orderbyDate(allBlogData?.news!))?.map((novelty, i) => {
      return {
        title: novelty.title,
        top_string: getDateTime(novelty) || '',
        link: novelty?.id ? `${divisionPath ?? ''}/novedad/${novelty.id}/${novelty.slug}` : '/',
        cta: 'VER NOVEDAD',
        paragraph: getTextShort(novelty.headline || '', 200),
        photo: novelty.image,
      }
    })
    return objects
  }

  return !isComponentMounted ? null : allBlogData && <Slider_6 slide_items={makeObject()} />
}

export default Summary_Novelty_5
